import type { ProductPage } from './productView'
import type { Product } from './types'

/* ─── The preview vote's feature identifier (ARCHITECTURE_DECISIONS.md §64) ───
   Agent Studio's convention (its lib/mcpVoteFeature.ts), applied here: the
   `preview.interest_vote` event carries feature / direction / account / user /
   timestamp and no page field, so the feature identifier is the only place
   the surface can be recorded, and it carries it:

       "Mambu Agents (Excess Volume)"  → a product preview card on that page
       "Monthly Limits"                → a coming-soon page's own card

   To total the demand for one product across pages, PREFIX-match the product
   name. These strings are ANALYTICS KEYS, not UI copy: deliberately hardcoded
   English, never passed through t() — a localised key would split the signal
   by the voter's language. They are never rendered; the toast names the
   feature with the translated title instead. */

/** One English surface name per page carrying a product preview card. An
 * explicit map, so a new page has to name its own series rather than fold
 * into an existing one. */
const PRODUCT_PAGE_SURFACE: Record<ProductPage, string> = {
  subscription: 'Subscription',
  'additional-volume': 'Additional Volume',
  'excess-volume': 'Excess Volume',
  'user-limits': 'User Limits',
  usage: 'Usage',
}

/** The feature a product preview card's vote records: the product, and the
 * page it was cast on. */
export function productPreviewVoteFeature(product: Product, page: ProductPage): string {
  return `${product} (${PRODUCT_PAGE_SURFACE[page]})`
}

/** The features the coming-soon pages vote on — the feature itself, as there
 * is no product. */
export const COMING_SOON_VOTE_FEATURE = {
  monthlyLimits: 'Monthly Limits',
  tenantLimits: 'Tenant Limits',
} as const
